import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-helment",
  "use": "icon-helment-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-helment\"><path d=\"M142.6432 736.8704h739.4304a85.4016 85.4016 0 0 0 16.1792-169.2672v-0.6656a385.024 385.024 0 0 0-272.7936-368.9472v-1.1264a62.7712 62.7712 0 0 0-62.6688-62.72h-100.864A62.7712 62.7712 0 0 0 399.36 196.864v1.1264a385.0752 385.0752 0 0 0-272.896 368.9472v0.6656a85.4016 85.4016 0 0 0 16.1792 169.2672z m0-109.3632h14.5408a30.72 30.72 0 0 0 30.72-30.72v-29.8496A323.6352 323.6352 0 0 1 399.36 262.912V440.32h61.44V220.16v-23.296a1.28 1.28 0 0 1 1.2288-1.28h100.864a1.2288 1.2288 0 0 1 1.2288 1.28V440.32h61.44V262.912a323.584 323.584 0 0 1 211.3536 304.0256v29.8496a30.72 30.72 0 0 0 30.72 30.72h14.5408a23.9616 23.9616 0 1 1 0 47.9232H142.6432a23.9616 23.9616 0 0 1 0-47.9232zM81.5104 821.7088h861.6448v61.44H81.5104z\" p-id=\"39211\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/helment.svg
// module id = Xc3i
// module chunks = 197